const rightHandKeys = 'YUIOPHJKLNM67890';

const symbolNames = {
  "'": 'apost',
  '.': 'period',
  ',': 'comma',
  ';': 'semicolon',
  '`': 'tilde',
  '=': 'equal',
  '[': 'bracket1',
  ']': 'bracket2',
  '/': 'fslash',
  '\\': 'bslash',
  ' ': 'space',
  '!': 'exclamation',
  '@': 'at',
  '#': 'hash',
  $: 'dollar',
  '%': 'percent',
  '^': 'carot',
  '&': 'ampersand',
  '*': 'asterix',
  '(': 'paren-left',
  ')': 'paren-right',
  '-': 'dash',
  '+': 'plus',
  '<': 'less',
  '>': 'greater',
  '?': 'question-mark',
  '"': 'dblquote',
  ':': 'colon'
};

const shiftTranslator = {
  quotationmark: "'",
  ':': ';',
  '"': "'",
  '{': '[',
  '}': ']',
  '?': '/',
  '<': ',',
  '>': '.',
  _: '-',
  '+': '=',
  '~': '`',
  '!': '1',
  '@': '2',
  '#': '3',
  $: '4',
  '%': '5',
  '^': '6',
  '&': '7',
  '*': '8',
  '(': '9',
  ')': '0'
};

const touchKeyShiftTranslator = {
  '?': '.',
  '!': ','
};

const keyNames = {
  dblquote: '"',
  space: ' '
};

export function getTargetKey(availableKeys = '') {
  if (!availableKeys) return '';

  const [givenKey] = availableKeys.toUpperCase();
  return rightHandKeys.includes(givenKey) ? 'f' : 'j';
}

export function convertNameToSymbol(keyName) {
  if (keyName.length === 1) return keyName;
  return keyNames[keyName] || keyName;
}

export function convertSymbolToName(key) {
  return symbolNames[key] || key;
}

export function adjustForShift(key, isTouchKeys) {
  const translator = isTouchKeys ? touchKeyShiftTranslator : shiftTranslator;
  return translator[key] || key.toLowerCase();
}

export default {
  convertSymbolToName,
  convertNameToSymbol,
  adjustForShift
};
